<template>
  <ul class="list-group list-group-flush">
    <li
      v-for="dialog in dialogs"
      :key="dialog.id"
      :class="['list-group-item d-flex align-items-center justify-content-between', { active_dialog: selectedDialog?.id === dialog.id }]"
      @click="$emit('select-dialog', dialog)"
      style="cursor: pointer;"
    >
      <div class="d-flex align-items-center w-100 justify-content-between">
        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
          <el-avatar
            :size="40"
            :src="getAvatar(dialog)"
            class="me-3 flex-shrink-0"
            style="background-color: #f56a00; color: var(--ui-color-white);"
          >
            <template v-if="!getAvatar(dialog)">{{ clientName(dialog.client_name) }}</template>
          </el-avatar>

          <div class="contact-info flex-grow-1 overflow-hidden">
            <div class="top-row d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center overflow-hidden">
                <font-awesome-icon :icon="getMessengerIcon(dialog.messenger_type)" class="messenger-icon" />
                <el-text truncated class="client-name">{{ dialog.client_name }}</el-text>
              </div>
              <el-badge
                :value="dialog.unread_count"
                v-if="dialog.unread_count > 0"
                class="unread-badge"
              />
            </div>
            <div class="bottom-row text-muted small message-date text-start">
              {{ formatLastMessageDate(dialog.last_active) }}
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DialogsList',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('messengers', ['dialogs']),
    ...mapState('socket', ['selectedDialog'])
  },
  methods: {
    clientName(name) {
      if (!name) return ''
      const parts = name.trim().split(' ').filter(Boolean)
      if (parts.length === 0) return ''
      if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase()
      }
      return (parts[0][0] + parts[1][0]).toUpperCase()
    },
    getMessengerIcon(type) {
      switch (type) {
        case 'whatsapp':
          return ['fab', 'whatsapp']
        case 'telegram':
          return ['fab', 'telegram']
        case 'vk':
          return ['fab', 'vk']
        case 'email':
          return ['far', 'envelope']
        default:
          return ['far', 'circle-question']
      }
    },
    getAvatar(dialog) {
      if (dialog.client_avatar) return dialog.client_avatar
      if (dialog.client_sex === 1) return '/img/avatar-male.svg'
      if (dialog.client_sex === 2) return '/img/avatar-female.svg'
      return null
    },
    formatLastMessageDate(date) {
      if (!date) return ''
      const d = new Date(date.replace(' ', 'T'))
      const now = new Date()
      const isToday = d.toDateString() === now.toDateString()
      const yesterday = new Date(now)
      yesterday.setDate(now.getDate() - 1)
      const isYesterday = d.toDateString() === yesterday.toDateString()

      const optionsTime = { hour: '2-digit', minute: '2-digit' }
      const optionsDate = { day: '2-digit', month: 'short', year: 'numeric' }

      if (isToday) {
        return `Сегодня в ${d.toLocaleTimeString([], optionsTime)}`
      } else if (isYesterday) {
        return `Вчера в ${d.toLocaleTimeString([], optionsTime)}`
      } else {
        return d.toLocaleDateString([], optionsDate)
      }
    }
  }
}
</script>
<style scoped>
.active_dialog {
  background-color: #dcf8fc;
}
.messenger-icon {
  margin-right: 6px;
  font-size: 18px;
  vertical-align: middle;
}
.last-message-time {
  font-size: 11px;
  color: var(--ui-color-text-muted);
  margin-top: 2px;
}
.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ui-color-border-subtle);
  transition: background 0.2s ease;
  min-height: 60px;
}
.list-group-item:hover {
  background-color: #f5f7fa;
}
.contact-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.client-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.bottom-row {
  margin-top: 2px;
}

.message-date {
  font-size: 12px;
  color: var(--ui-color-text-muted);
}
.right-side {
  min-width: 110px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.unread-badge {
  --el-badge-size: 18px;
  margin-left: 4px;
  transform: none;
  margin-top: 5px;
}

.el-avatar {
  flex-shrink: 0;
}
</style>
